import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store';
import Login from '@/views/login/Login.vue'
import Dashboard from '@/views/dashboard/Dashboard.vue'
import MainLayout from '@/layouts/MainLayout.vue';
import Setting from '@/views/dashboard/Setting.vue';
import ListeUser from '@/views/user/ListeUser.vue';
import CreateUser from '@/views/user/CreateUser.vue';
import EditUser from '@/views/user/editUser.vue';
import ListeTypeUser from '@/views/typeUser/ListeTypeUser.vue';
import Test from '@/views/user/Test.vue'
import CreateTypeUser from '@/views/typeUser/CreateTypeUser.vue';
import ListePatient from '@/views/patient/ListePatient.vue';
import CreatePatient from '@/views/patient/CreatePatient.vue';
import EditPatient from '@/views/patient/editPatient.vue';
import Dossier from '@/views/patient/Dossier.vue';
import ListeTypeConsultation from '@/views/typeConsultation/ListeTypeConsultation.vue';
import CreateTypeConsultation from '@/views/typeConsultation/CreateTypeConsultation.vue';
import EditTypeConsultation from '@/views/typeConsultation/EditTypeConsultation.vue';
import ListeConsultation from '@/views/consultation/ListeConsultation.vue';
import RecuConsultation from '@/views/consultation/consultation/RecuConsultation.vue';
import ListeAssurance from '@/views/assurance/ListeAssurance.vue';
import CreateAssurance from '@/views/assurance/CreateAssurance.vue';
import ConfigurationSysteme from '@/views/config/ConfigurationSysteme.vue';
import CreateConfiguration from '@/views/config/CreateConfiguration.vue';
import EditConfigurationSysteme from '@/views/config/EditConfigurationSysteme.vue';
import ListePaiementConsultation from '@/views/consultation/consultation/ListePaiementConsultation.vue';
import EditAssurance from '@/views/assurance/EditAssurance.vue';
import ListeMedicament from '@/views/pharmacie/ListeMedicament.vue';
import CreateMedicament from '@/views/pharmacie/CreateMedicament.vue';
import TraitementConsultation from '@/views/consultation/TraitementConsultation.vue';
import ListeConditionnement from '@/views/conditionnement/ListeConditionnement.vue';
import CreateConditionnement from '@/views/conditionnement/CreateConditionnement.vue';
import EditConditionnement from '@/views/conditionnement/EditConditionnement.vue';
import ListeApprovisionnement from '@/views/approvisionnement/ListeApprovisionnement.vue';
import CreateApprovisionnement from '@/views/approvisionnement/CreationApprovisionement.vue';
import EditApprovisionnement from '@/views/approvisionnement/EditApprovisionnement.vue';
import DetailsMedicament from '@/views/pharmacie/DetailsMedicament.vue';
import EditTraitement from '@/views/consultation/EditTraitement.vue';
import ListeTypeChambre from '@/views/typeChambre/ListeTypeChambre.vue';
import CreateTypeChambre from '@/views/typeChambre/CreateTypeChambre.vue';
import EditTypeChambre from '@/views/typeChambre/EditTypeChambre.vue';
import ListeChambre from '@/views/chambre/ListeChambre.vue';
import CreateChambre from '@/views/chambre/CreateChambre.vue';
import EditChambre from '@/views/chambre/EditChambre.vue';
import ListeLit from '@/views/lit/ListeLit.vue';
import CreateLit from '@/views/lit/CreateLit.vue';
import EditLit from '@/views/lit/EditLit.vue';
import ListeTypeHospitalisation from '@/views/typeHospitalisation/ListeTypeHospitalisation.vue';
import CreateTypeHospitalisation from '@/views/typeHospitalisation/CreateTypeHospitalisation.vue';
import EditTypeHospitalisation from '@/views/typeHospitalisation/EditTypeHospitalisation.vue';
import ListeHospitalisation from '@/views/hospitalisation/ListeHospitalisation.vue';
import CreateHospitalisation from '@/views/hospitalisation/CreateHospitalisation.vue';
import ListeMoyenPaiement from '@/views/moyenPaiement/ListeMoyenPaiement.vue';
import CreateMoyenPaiement from '@/views/moyenPaiement/CreateMoyenPaiement.vue';
import ReçuHospitalisation from '@/views/hospitalisation/ReçuHospitalisation.vue';
import Unauthorized from '@/views/Unauthorized.vue';
import EditTypeUser from '@/views/typeUser/EditTypeUser.vue';
import Compte from '@/views/user/Compte.vue';
import Information from '@/views/patient/tabs/Information.vue';
import ListeTypeExamen from '@/views/typeExamen/ListeTypeExamen.vue';
import CreateTypeExamen from '@/views/typeExamen/CreateTypeExamen.vue';
import EditTypeExamen from '@/views/typeExamen/EditTypeExamen.vue';
import ListeFrequence from '@/views/frequence/ListeFrequence.vue';
import CreateFrequence from '@/views/frequence/CreateFrequence.vue';
import EditFrequence from '@/views/frequence/EditFrequence.vue';
import ListeDureeMedicament from '@/views/dureMedicament/ListeDureeMedicament.vue';
import CreateDureeMedicament from '@/views/dureMedicament/CreateDureeMedicament.vue';
import EditDureeMedicament from '@/views/dureMedicament/EditDureeMedicament.vue';
import DetailsHospitalisation from '@/views/hospitalisation/DetailsHospitalisation.vue';
import ListePaiement from '@/views/transaction/ListePaiement.vue';
import ListeTypeService from '@/views/typeService/ListeTypeService.vue';
import EditTypeService from '@/views/typeService/EditTypeService.vue';
import CreateTypeService from '@/views/typeService/CreateTypeService.vue';
import ListeService from '@/views/service/ListeService.vue';
import CreateService from '@/views/service/CreateService.vue';
import EditService from '@/views/service/EditService.vue';



const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    component: MainLayout,//Layout principal

    children: [
      {
        path: '',
        name:'Dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true,
          permissions: ['DASHBOARD']
        }
      },
      {
        path: '/compte',
        name: 'compte',
        component: Compte,
        meta: { 
          requiresAuth: true 
        },
      },

      // Patients CRUD

       {
        path:'/patients',
        name: 'patients',
        component: ListePatient,
         meta: {
           requiresAuth: true,
           permissions: ['PATIENT_LIST']
          
        }
       },
        {
        path: '/patients/creation',
        name: 'create_patient',
        component: CreatePatient,
        meta: {
          requiresAuth: true,
          permissions: ['PATIENT_CREATE']
        }
      },
      {
        path: '/patients/:id',
        name: 'edit_patient',
        component: EditPatient,
         meta: {
          requiresAuth: true,
          permissions: ['PATIENT_EDIT']
        }
      },
      {
        path: 'consultations_',
        name:'consultations_',
        component: ListeConsultation,
         meta: {
           requiresAuth: true,
           permissions: ['CONSULT_VIEW']
          
        }
      },
      {
      path: '/consultation/:id/recu',
      name: 'recu_consultation',
      component: RecuConsultation,
      meta: {
           requiresAuth: true,
           permissions: ['CONSULT_IMPRESSION']
          
        }
      },
      {
        path:'/assurances',
        name: 'liste_assurance',
        component: ListeAssurance,
         meta: {
        requiresAuth: true,
        permissions: ['CONFIG_LISTE_ASSURANCE']
        }

      },
      {
        path: '/assurances/:id',
        name: 'edit_assurance',
        component: EditAssurance,
        meta: {
        requiresAuth: true,
        permissions: ['CONFIG_Modifier_ASSURANCE']
        }

      },
      {
        path: '/configurations',
        name: 'item_config',
        component: ConfigurationSysteme,
         meta: {
        requiresAuth: true,
        permissions: ['VIEW_CONFIGURATION_SYSTEME']
        }
        
      },
      {
        path: '/configurations/creation',
        name: 'create_configuration_systeme',
        component: CreateConfiguration,
         meta: {
          requiresAuth: true,
          permissions: ['CREATE_CONFIGURATION_SYSTEME']
        }

      },
      /*{
        path: '/traitements/:id',
        name: 'traitement_consultation',
        component: Traitement

      },*/

      {
        path: '/configurations/:id/edit',
        name: 'edit_configuration_systeme',
        component: EditConfigurationSysteme,
        meta: {
          requiresAuth: true,
          permissions: ['EDIT_CONFIGURATION_SYSTEME']
        }
        
      },
      {
        path: '/conditionnements',
        name: 'conditionnements',
        component: ListeConditionnement,
        meta: {
         requiresAuth: true,
         permissions: ['CONFIG_LISTE_CONDITIONNEMENT']
        }
      },
      {
        path: '/conditionnements/nouveau',
        name: 'create_conditionnement',
        component: CreateConditionnement,
         meta: {
         requiresAuth: true,
         permissions: ['CONFIG_CREER_CONDITIONNEMENT']
        }

       

      },
      {
        path: '/conditionnements/:id',
        name: 'edit_conditionnement',
        component: EditConditionnement,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_CONDITIONNEMENT']
        }

        
      },
      {
        path: '/approvisionnements',
        name: 'liste_approvisionnement',
        component: ListeApprovisionnement,
         meta: {
          requiresAuth: true,
          permissions: ['LISTE_APPROVISIONNEMENT']
        }

      },
      {
        path: '/approvisionnements/:id',
        name: 'edit_approvisionnement',
        component: EditApprovisionnement,
         meta: {
          requiresAuth: true,
          permissions: ['EDIT_APPROVISIONNEMENT']
        }

      },
      {
        path: '/approvisionnements/nouveau',
        name: 'create_approvisionnement',
        component: CreateApprovisionnement,
        meta: {
          requiresAuth: true,
          permissions: ['CREER_APPROVISIONNEMENT']
        }
      },

      {
        path: '/assurances/creation',
        name: 'create_assurance',
        component: CreateAssurance,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_ASSURANCE']
        }

      },
      {
        path: '/medicaments',
        name: 'liste_medicaments',
        component: ListeMedicament,
        meta: {
          requiresAuth: true,
          permissions: ['view_pharmacie']
        }
      },
      {
  path: "/produits",
  name: "produits",
  component: () => import("@/views/produits/ProduitList.vue")
},
 {
  path: "/produits",
  name: "create_produit",
  component: () => import("@/views/produits/CreateProduit.vue")
},
 {
  path: "/produits/:id",
  name: "edit_produit",
  component: () => import("@/views/produits/EditProduit.vue")
},

{
  path: "/approvs",
  name: "approvs",
  component: () => import("@/views/approv/ListeApprov.vue")
},
{
  path: "/approvs",
  name: "approv-creation",
  component: () => import("@/views/approv/CreateApprov.vue")
},
/*
{
  path: "/ventes",
  name: "ventes",
  component: () => import("@/views/ventes/VenteCaisse.vue")
},
{
  path: "/stock",
  name: "stock",
  component: () => import("@/views/stock/StockView.vue")
},*/
      {
        path: '/medicaments/nouveau',
        name: 'create_medicament',
        component: CreateMedicament,
        meta: {
           requiresAuth: true,
           permissions: ['MEDICAMENT_CREER']
          
        }
      },
      {
        path: '/medicaments/:id/details',
        name: 'details',
        component: DetailsMedicament,
        meta: {
           requiresAuth: true,
           permissions: ['MEDICAMENT_DETAILS']
          
        }
      },
       {
        path: '/paiements',
        name: 'liste_paiements',
        component: ListePaiement,
        meta: {
          requiresAuth: true,
          permissions: ['TRANS_LIST_AUTRES_SERVICES']
        }
        
      },
      {
        path: '/paiement_consultations_',
        name: 'liste_paiement_consultation',
        component: ListePaiementConsultation,
        meta: {
          requiresAuth: true,
          permissions: ['TRANS_LIST_CONSULTATION']
        }
        
      },
      {
        path: '/consultations/:id/traitements',
        name: 'traitement_consultation',
        component: TraitementConsultation,
         meta: {
          requiresAuth: true,
          permissions: ['CONSULT_TRAITER']
        }

      },
      {
        path: '/consultations/:id/traitements/modification',
        name: 'edit_traitement',
        component: EditTraitement,
        meta: {
          requiresAuth: true,
          permissions: ['CONSULT_TRAITER']
        }

      },

       {
        path: '/dossiers/:id',
        name: 'dossier_patient',
        component: Dossier,
           meta: {
          requiresAuth: true,
          permissions: ['PATIENT_DOSSIER']
        },
        children: [
    {
      path: '',
      redirect: { name: 'information_personnelle' }
    },
    {
      path: 'informations',
      name: 'information_personnelle',
      component: Information,
      

    },
    {
      path: 'consultations',
      name: 'consultations_patient',
      component: () => import('@/views/patient/tabs/ConsultationsPatient.vue')
    },
    {
      path: 'ordonnances',
      name: 'ordonnances_patient',
      component: () => import('@/views/patient/tabs/OrdonnancesPatient.vue'),
    },
    {
      path: 'factures',
      name: 'factures_patient',
      component: () => import('@/views/patient/tabs/FacturesPatient.vue')
    },
    {
      path: 'analyses',
      name: 'analyses_patient',
      component: () => import('@/views/patient/tabs/AnalysesPatient.vue')
    },
    {
      path: 'hospitalisations',
      name: 'hospitalisations_patient',
      component: () => import('@/views/patient/tabs/HospitalisationPatient')
    },
    {
     path: '/patients/:id/services',
     name: 'services_patient',
     component: () => import('@/views/patient/tabs/PatientServices.vue'),
     props: true
    }
    
  ]
       },
      {
        path: '/setting',
        name: 'setting',
        component: Setting
      },
      {
        path: '/hospitalisation/:id/details',
        name: 'details_hospitalisation',
        component: DetailsHospitalisation,
        meta: {
          requiresAuth: true,
          permissions: ['HOSP_DESTAILS']
        }
      },

      {
        path:'/type_services',
        name: 'liste_type_service',
        component: ListeTypeService,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_TYPE_Service']
        }
      },
      {
        path: '/type_services/:id',
        name: 'edit_type_service',
        component: EditTypeService,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_SERVICE']
        }
      },
      {
        path: '/type_service',
        name: 'create_type_service',
        component: CreateTypeService,
          meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_TYPE_SERVICE']
        }
      },
      {
        path: '/services',
        name: 'liste_service',
        component: ListeService,
          meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_SERVICE']
        }
      },
      {
        path: '/services',
        name: 'create_service',
        component: CreateService,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_SERVICE']
        }

      },
       {
        path: '/services/:id',
        name: 'edit_service',
        component: EditService,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_SERVICE']
        }

      },
      
      //Type examen 

      {
        path: '/type_examens',
        name: 'liste_type_examen',
        component: ListeTypeExamen,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_TYPE_EXAMEN']
        }

      },
      {
        path: 'type_examens',
        name: 'create_type_examen',
        component: CreateTypeExamen,
          meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_TYPE_EXAMEN']
        }
      },
      {
        path: '/type_examens/:id',
        name: 'edit_type_examen',
        component: EditTypeExamen,
          meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_EXAMEN']
        }

      },

      {
        path: '/frequences',
        name: 'liste_frequence',
        component: ListeFrequence,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_FREQUENCE']
        }

      },
      {
        path: '/frequences',
        name: 'create_frequence',
        component: CreateFrequence,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_FREQUENCE']
        }
      },
      {
        path: '/frequences/:id',
        name: 'edit_frequence',
        component: EditFrequence,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_EXAMEN']
        }
      },

      {
        path: '/duree_medicaments',
        name: 'liste_duree_medicament',
        component: ListeDureeMedicament,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_DUREE_MEDICAMENT']
        }
      },
      {
        path: '/duree_medicaments',
        name: 'create_duree_medicament',
        component: CreateDureeMedicament,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_DUREE_MEDICAMENT']
        }
      },
      {
        path: '/dure_medicaments/:id',
        name: 'edit_duree_medicament',
        component: EditDureeMedicament,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_DUREE_MEDICAMENT']
        }
      },
      // Utilisateur CRUD
      {
        path: '/utilisateurs',
        name: 'utilisateur',
        component: ListeUser,
        meta: {
          requiresAuth: true,
          permissions: ['ADMIN_LISTE_UTILISATEUR']
        }
      },
      {
        path: '/utilisateurs/creation',
        name: 'create_utilisateur',
        component: CreateUser,
        meta: {
          requiresAuth: true,
          permissions: ['ADMIN_CREATE_UTILISATEUR']
        }
      },
      {
        path: '/utilisateurs/:id',
        name: 'edit_user',
        component: EditUser,
        meta: {
          requiresAuth: true,
          permissions: ['ADMIN_EDIT_UTILISATEUR']
        }
      },
      {
        path: '/moyen_paiements',
        name: 'liste_moyen_paiement',
        component: ListeMoyenPaiement,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MOYEN_PAIEMENT']
        }
        
      },
      {
        path: '/moyen_paiements',
        name: 'create_moyen',
        component: CreateMoyenPaiement,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_MOYEN__PAIEMENT']
        }
      },

      {
        path: '/type_chambres',
        name: 'liste_type_chambre',
        component: ListeTypeChambre,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_TYPE_CHAMBRE']
        }

      },
      {
        path: '/type_chambres',
        name: 'create_type_chambre',
        component: CreateTypeChambre,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_TYPE_CHAMBRE']
        }
      },
      {
        path: '/type_chambres/:id',
        name: 'edit_type_chambres',
        component: EditTypeChambre,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_CHAMBRE']
        }
        
      },
      {
        path: '/chambres',
        name: 'liste_chambre',
        component: ListeChambre,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CHAMBRE']
        }

      },
      {
        path: '/chambres',
        name: 'create_chambre',
        component: CreateChambre,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_CHAMBRE']
        }
      },
      {
        path: '/chambres/:id',
        name: 'edit_chambre',
        component: EditChambre,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_CHAMBRE']
        }

        
      },
      //Lits
      {
        path: '/lits',
        name: 'liste_lit',
        component: ListeLit,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LIT']
        }
      },
      {
        path: '/lits',
        name: 'create_lit',
        component: CreateLit,
          meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_LIT']
        }
      },
      {
        path: '/lits/:id',
        name: 'edit_lit',
        component: EditLit,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_LIT']
        }

      },
      //Type Hospitalisation
      {
        path: '/type_hospitalisations',
        name: 'liste_type_hospitalisation',
        component: ListeTypeHospitalisation,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_TYPE_HOSPITALISATION']
        }
      },
      {
        path: '/type_hospitalisations',
        name: 'create_type_hospitalisation',
        component:CreateTypeHospitalisation,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_TYPE_HOSPITALISATION']
        }
      },
      {
        path: '/type_hospitalisation/:id',
        name: 'edit_type_hospitalisation',
        component: EditTypeHospitalisation,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_HOSPITALISATION']
        }
      },
      //Hospitalisation
      {
        path: '/hospitalisations',
        name: 'liste_hospitalisation',
        component: ListeHospitalisation,
        meta: {
          requiresAuth: true,
          permissions: ['HOSP_VIEW']
        }

        

      },
      {
        path: '/hospitalisations',
        name: 'create_hospitalisation',
        component: CreateHospitalisation,
         meta: {
          requiresAuth: true,
          permissions: ['HOSP_CREATE']
        }
      },
      {
        path: '/recu_hospitalisation/:id',
        name: 'reçu_hospitalisation',
        component: ReçuHospitalisation,
        


      },
      //Type Consultation
      {
        path: '/type_consultations',
        name: 'type_consultation',
        component: ListeTypeConsultation,
        meta: {
        requiresAuth: true,
        permissions: ['CONFIG_LISTE_TYPE_CONSULTATION']
  }

      },
      {
        path: '/type_consultation/creation',
        name: 'create_type_consultation',
        component: CreateTypeConsultation,
         meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_TYPE_CONSULTATION']
        }
      },
      {
        path: '/type_consultations/:id',
        name: 'edit_type_consultation',
        component: EditTypeConsultation,
          meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_CONSULTATION']
        }
      },
      // Routes Type Utilisateur
      {
        path: '/roles',
        name: 'role',
        component: ListeTypeUser,
         meta: {
          requiresAuth: true,
          permissions: ['ADMIN_LISTE_ROLE']
        }
        
      },
      {
        path: '/type_users/creation',
        name: 'create_type_users',
        component: CreateTypeUser,
           meta: {
          requiresAuth: true,
          permissions: ['ADMIN_CREER_ROLE']
        }

      },
       {
        path: '/type_users/:id/edit',
        name: 'edit_type_users',
        component: EditTypeUser,
         props: true,
           meta: {
          requiresAuth: true,
          permissions: ['ADMIN_MODIFIER_ROLE']
        }
      },
      {
  path: '/unauthorized',
  name: 'unauthorized',
  component: Unauthorized
},
      {
        path: '/test',
        name: 'test',
        component: Test
      }
    ],
    meta: {requiresAuth: true}
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});
/*router.beforeEach((to, from, next) => {
  next(); // autorise toutes les routes sans authentification
});*/
/*router.beforeEach((to, from, next) => {
  const isAuthenticated = JSON.parse(localStorage.getItem('isAuthenticated')) || false;
  const user = JSON.parse(localStorage.getItem('user')) || null;
  console.log(user);
  if(to.meta.requiresAuth && !isAuthenticated) {
    next('/login');
  } 
  if (user) {
    if (to.meta.roles) {
      const hasRole = to.meta.roles.some(role => user.roles.includes(role));
      if (!hasRole) return next('/unauthorized');
    }

    if (to.meta.permissions) {
      const hasPermission = to.meta.permissions.some(perm => user.permissions.includes(perm));
      if (!hasPermission) return next('/unauthorized');
    }
  }

  next();
})*/



/*router.beforeEach((to, from, next) => {
  const isAuthenticated = JSON.parse(localStorage.getItem('isAuthenticated')) || false;
  const user = JSON.parse(localStorage.getItem('user')) || null;

  
  //  Non authentifié  login
   if (to.meta.requiresAuth && (!isAuthenticated || !user)) {
    return next('/login');
  }

  //  Si pas d'utilisateur connecté, continuer
  if (!user) {
    return next();
  }

  const userPermissions = (user.permissions || []).map(p => p.toLowerCase());
  const isSuperAdmin = user?.typeUser?.toLowerCase() === 'Super Admin';

  // Fonction utilitaire : retourne la première route accessible correspondant à une page de LISTING
  const getFirstListingRoute = () => {
    const allRoutes = router.getRoutes();

    // Cherche la première route dont la permission contient "LIST"
    return allRoutes.find(r =>
      r.meta?.permissions?.some(perm =>
        userPermissions.includes(perm.toLowerCase()) && perm.toLowerCase().includes('list')
      )
    );
  };


  //  Cas Super Admin → accès total
  if (isSuperAdmin) {
    return next();
  }

  //  Si utilisateur n’a pas le droit d’accéder au dashboard
  if (to.path === '/' && !userPermissions.includes('dashboard')) {
    const accessibleRoute = getFirstListingRoute();
    if (accessibleRoute) {
      return next({ name: accessibleRoute.name });
    } else {
      return next('/unauthorized');
    }
  }

  //  Vérifie les permissions pour les autres routes
  if (to.meta.permissions) {
    const hasPermission = to.meta.permissions.some(perm =>
      userPermissions.includes(perm.toLowerCase())
    );

    if (!hasPermission) {
      const accessibleRoute = getFirstListingRoute();
      if (accessibleRoute) {
        return next({ name: accessibleRoute.name });
      } else {
        return next('/unauthorized');
      }
    }
  }

  return next();
});*/

router.beforeEach((to, from, next) => {
  const isAuthenticated = JSON.parse(localStorage.getItem('isAuthenticated')) || false;
  const user = JSON.parse(localStorage.getItem('user')) || null;

  // Non authentifié
  if (to.meta.requiresAuth && (!isAuthenticated || !user)) {
    return next('/login');
  }

  if (!user) return next();

  // Permissions de l'utilisateur
  const userPermissions = (user.permissions || []).map(p => p.toLowerCase());

  // Super Admin
  const isSuperAdmin = user?.typeUser?.toLowerCase() === 'super admin';
  if (isSuperAdmin) return next(); // accès total

  // Fonction utilitaire : première route LIST accessible
  const getFirstListingRoute = () => {
    const allRoutes = router.getRoutes();
    return allRoutes.find(r =>
      r.meta?.permissions?.some(
        perm => userPermissions.includes(perm.toLowerCase()) && perm.toLowerCase().includes('list')
      )
    );
  };

  // Dashboard
  if (to.path === '/' && !userPermissions.includes('dashboard')) {
    const accessibleRoute = getFirstListingRoute();
    if (accessibleRoute) return next({ name: accessibleRoute.name });
    else return next('/unauthorized');
  }

  // Vérification permissions pour les autres routes
  if (to.meta.permissions) {
    const hasPermission = to.meta.permissions.some(perm =>
      userPermissions.includes(perm.toLowerCase())
    );

    if (!hasPermission) {
      const accessibleRoute = getFirstListingRoute();
      if (accessibleRoute) return next({ name: accessibleRoute.name });
      else return next('/unauthorized');
    }
  }

  return next();
});






export default router
